<div class="modal-background" bdFxLayoutAlign="center start" (click)="onModalClicked()">
    <div class="projects-modal" [ngClass]="{'force-full-height': !isInitialized }">
        <div bdFxLayoutAlign="space-between center" class="header">
            <div bdFxFlex bdFxLayoutAlign="start center" class="cancel">
                <button (click)="onCancelBtnClicked()" type="button">Abbrechen</button>
            </div>
            <div bdFxFlex bdFxLayoutAlign="center center"
                 class="title">{{editModalService.isNewProject() ? 'Neues Projekt' : 'Anfrage'}}</div>
            <div bdFxFlex bdFxLayoutAlign="end center" class="save">
                <button class="bd-blue-button" (click)="onTopSubmitBtnClicked()" type="button"
                        *ngIf="isTopSaveBtnVisible()"
                        [disabled]="isTopSaveBtnDisabled()">
                    {{editModalService.isNewProject() ? 'Anfrage speichern' : 'Speichern'}}
                </button>
            </div>
        </div>
        <div class="divider"></div>
        <div *ngIf="dialogModel">
            <div class="body">
                <app-projects-stepper #stepper
                                      (nextBtnClicked)="onNextBtnClicked()"
                                      (previousBtnClicked)="onPreviousBtnClicked()"
                                      (dotClicked)="onDotClicked($event)"
                                      [selectedIndex]="stepIndexToOpenWith"
                                      [maxClickableStepIndex]="maxClickableStepIndex"
                                      [maxValidatedStepIndex]="maxValidatedStepIndex"
                                      [isLinear]="is1StepActive() && maxClickableStepIndex === stepEnum.STEP1"
                                      [isNextBtnDisabled]="isNextBtnDisabled()"
                                      [showDotsValidation]="true">
                    <cdk-step [stepControl]="userDataForm.form" [id]="getStepIdAsString(stepEnum.STEP1)">
                        <div class="scroll-area" (scroll)="onScroll()" #scrollArea>


                            <form #userDataForm="ngForm">
                                <app-projects-end-user-data-editor
                                    [forceFormValidationVisibility]="dialogModel.isFirstStepSaveValidationVisibilityForced">
                                </app-projects-end-user-data-editor>
                            </form>

                            <div class="footer">

                                <div class="divider"></div>
                                <div class="mandatory-info">
                                    Mit * gekennzeichnete Felder sind Pflichtfelder
                                </div>
                                <button (click)="onNextBtnClicked()"
                                        [disabled]="isNextBtnDisabled()"
                                        type="button">
                                    Weiter
                                </button>

                            </div>
                        </div>

                    </cdk-step>

                    <cdk-step [stepControl]="projectDataForm.form" [id]="getStepIdAsString(stepEnum.STEP2)">
                        <div class="scroll-area" (scroll)="onScroll()" #scrollArea>

                            <form #projectDataForm="ngForm">
                                <app-dialog-step2-section-controller
                                    [forceFormValidationVisibility]="forceStepValidation(stepEnum.STEP2)"></app-dialog-step2-section-controller>
                            </form>

                            <div class="footer">

                                <div class="divider"></div>
                                <div class="mandatory-info">
                                    Mit * gekennzeichnete Felder sind Pflichtfelder
                                </div>
                                <button (click)="onNextBtnClicked()"
                                        [disabled]="isNextBtnDisabled()"
                                        type="button">
                                    Weiter
                                </button>

                            </div>
                        </div>
                    </cdk-step>

                    <cdk-step [stepControl]="devicesDataForm.form" [id]="getStepIdAsString(stepEnum.STEP3)">
                        <div class="scroll-area" (scroll)="onScroll()" #scrollArea>

                            <app-no-order-items-info *ngIf="!dialogModel.isDeviceOrderRequested"
                                                     [connectedTableId]="MyContainersTableIdEnum.step3DeviceTableContainers">

                            </app-no-order-items-info>

                            <form #devicesDataForm="ngForm" class="step3">
                                <ng-container *ngIf="dialogModel.isDeviceOrderRequested">

                                    <app-projects-devices-table-editor
                                        [forceFormValidationVisibility]="forceStepValidation(stepEnum.STEP3)">
                                    </app-projects-devices-table-editor>

                                    <ng-container
                                        *ngIf="editModalService?.getDialogModel()?.containsSomeRequestedDevicesContainers()">
                                        <div class="divider mt25"></div>

                                        <app-additional-items-extension-editor

                                            [forceFormValidationVisibility]="forceStepValidation(stepEnum.STEP3)">
                                        </app-additional-items-extension-editor>
                                    </ng-container>

                                </ng-container>

                                <app-empty-containers-form-invalidator
                                    class="step3"
                                    [forceFormValidationVisibility]="forceStepValidation(stepEnum.STEP3)">
                                </app-empty-containers-form-invalidator>

                            </form>
                            <div class="footer pt0">

                                <div class="divider"></div>
                                <div class="mandatory-info">
                                    Mit * gekennzeichnete Felder sind Pflichtfelder
                                </div>

                                <button (click)="onNextBtnClicked()"
                                        [disabled]="isNextBtnDisabled()"
                                        type="button">
                                    Weiter
                                </button>

                            </div>
                        </div>
                    </cdk-step>

                    <cdk-step [stepControl]="additionalItemsDataForm.form" [id]="getStepIdAsString(stepEnum.STEP4)">
                        <div class="scroll-area" (scroll)="onScroll()" #scrollArea>

                            <form #additionalItemsDataForm="ngForm" class="step4">
                                <app-dialog-step4-section-controller
                                    [forceFormValidationVisibility]="forceStepValidation(stepEnum.STEP4)">

                                </app-dialog-step4-section-controller>

                                <app-empty-containers-form-invalidator
                                    class="step4"
                                    [forceFormValidationVisibility]="forceStepValidation(stepEnum.STEP4)">
                                </app-empty-containers-form-invalidator>

                            </form>
                            <div class="footer pt0">

                                <div class="divider"></div>
                                <div class="mandatory-info">
                                    Mit * gekennzeichnete Felder sind Pflichtfelder
                                </div>

                                <button (click)="onNextBtnClicked()"
                                        [disabled]="isNextBtnDisabled()"
                                        type="button">
                                    Weiter
                                </button>

                            </div>
                        </div>

                    </cdk-step>

                    <cdk-step [stepControl]="suppliesForm.form" [id]="getStepIdAsString(stepEnum.STEP5)">
                        <div class="scroll-area" (scroll)="onScroll()" #scrollArea>

                            <form #suppliesForm="ngForm" class="step5" novalidate>
                                <app-projects-dialog-step5-sections-controller
                                    [forceFormValidationVisibility]="forceStepValidation(stepEnum.STEP5)">
                                </app-projects-dialog-step5-sections-controller>
                            </form>
                            <div class="footer">

                                <div class="divider"></div>
                                <div class="mandatory-info">
                                    Mit * gekennzeichnete Felder sind Pflichtfelder
                                </div>

                                <button (click)="onNextBtnClicked()"
                                        [disabled]="isNextBtnDisabled()"
                                        type="button">
                                    Weiter
                                </button>

                            </div>
                        </div>
                    </cdk-step>

                    <cdk-step [id]="getStepIdAsString(stepEnum.STEP6)">
                        <div class="scroll-area" (scroll)="onScroll()" #scrollArea>

                            <div class="step6">
                                <app-projects-dialog-step6-sections-controller>
                                </app-projects-dialog-step6-sections-controller>
                            </div>
                            <div class="footer">

                                <div class="divider"></div>

                                <button (click)="onBottomSubmitBtnClicked()"
                                        [ngClass]="{'some-step-is-invalid': !stepper.allStepsAreValid()}"
                                        type="button">

                                    Absenden
                                </button>

                            </div>
                        </div>
                    </cdk-step>
                </app-projects-stepper>
            </div>


        </div>
    </div>
</div>


